var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVortexGovernment01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438 416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#09B2C9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M84.63,156.62,221.46,58.15,358,154.73v13.92H84.63Zm248.28,19.92V294.92H306.1V176.54Zm-49.93,0V294.92H256.17V176.54Zm-49.93,0V294.92H206.24V176.54Zm-48.08,0V294.92H158.16V176.54Zm-49.93,0V294.92H108.23V176.54ZM365.85,334.39H74.8V318.51h9.83V302.63H358v15.88h7.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVortexGovernment01);
export default __webpack_public_path__ + "static/media/Vortex_Government-01.78722ef36ca26711584f463bb4ab6631.svg";
export { ForwardRef as ReactComponent };